// SuccessAlert.tsx
import React, { useEffect } from 'react';
import { useAlert } from '../../context/alertContext';
import { MdClose } from 'react-icons/md';

const SuccessAlert: React.FC = () => {
  const { successMessage, setSuccessMessage } = useAlert();

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccessMessage(null);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!successMessage) return null;

  return (
    <div className="fixed left-[50%] top-[20px] z-[1000] m-auto flex w-[80vw] max-w-md -translate-x-1/2 transform gap-4 rounded-lg bg-green-600 p-4 shadow-lg">
      <p className="text-white">{successMessage}</p>
      <button
        onClick={() => setSuccessMessage(null)}
        className="ml-auto mt-2 rounded-full rounded-md bg-white px-4 py-2 text-green-600 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-500"
      >
        <MdClose />
      </button>
    </div>
  );
};

export default SuccessAlert;
